import { ReferField, ReferFieldDesc } from './ReferField';
import { FormStore, FieldDesc } from '../FormStore'
import { BaseField } from './BaseField';
import { CharacterField, CharacterFieldDesc } from './CharacterField';
import { NumberField, NumberFieldDesc } from './NumberField';
export type Field = ReferField |  BaseField | CharacterField | NumberField
export type Fields = ReferFieldDesc &  FieldDesc & CharacterFieldDesc & NumberFieldDesc

const CONTROLTYPES = {
  REFER: 'ReferInputPc',
  CHARACTER: 'Characteristics',
  NUMBER: 'InputNumber'
}

/**
 * class FieldFactory 根据controlType创建不同字段
 */
export class FieldFactory {
  formStore: FormStore
  constructor (formStore: FormStore) {
    this.formStore = formStore
  }
  createField (fieldDesc: any) {
    switch (fieldDesc?.controlType) {
      case CONTROLTYPES.REFER:
        // 暂时, 参照编码后续统一
      case 'ReferInput':
      case 'DeptReferInput':
      case 'UserReferInput':
        return new ReferField(fieldDesc, this.formStore)
      case CONTROLTYPES.CHARACTER:
        return new CharacterField(fieldDesc, this.formStore)
      case CONTROLTYPES.NUMBER:
        return new NumberField(fieldDesc, this.formStore)
      default:
        return new BaseField(fieldDesc, this.formStore);
        // throw new Error(`Unknown field type: ${type}`);
    }
  }
}